var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cus_vtree_wrap",on:{"!click":function($event){return _vm.clickNodeWrap($event)}}},[_c('v-tree-item',{class:{tree_root_lonely:_vm.treeData.length === 1},attrs:{"treeData":_vm.treeData,"transitionTime":_vm.transitionTime,"checkBox":_vm.checkBox},on:{"clickNodeCom":_vm.clickNode,"toggleCheckBox":_vm.checkBoxFun}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34554719","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ctree.vue
// module id = null
// module chunks = 